// Como o painel de Notificações traduz o resultado de um envio para o admin.
//
// Puro (sem firebase/RN) para ser testável: é esta lógica que responde
// "a notificação foi enviada ou não?" — a dúvida que originou o ticket, em que
// um doc aparecia como `failed` mas com a subcoleção de usuários populada.

// Tradução do `errorCode` gravado pela Cloud Function (scheduleNotificationAdmin)
// para uma mensagem que faça sentido ao admin. Códigos desconhecidos caem na
// `errorMessage` bruta; sem nenhum dos dois, num texto genérico.
export const ERROR_MESSAGES = {
  'no-matching-users': 'Nenhum aluno encontrado com os produtos/planos selecionados.',
  'abandoned-in-queue':
    'O envio ficou parado na fila por tempo demais e não foi entregue. Crie a notificação de novo.',
  'no-tokens': 'Nenhum aluno com notificações ativas foi encontrado para este envio.',
  timeout:
    'O envio passou do tempo limite e foi interrompido. Parte dos alunos pode não ter recebido.',
  'messaging/registration-token-not-registered':
    'O dispositivo não está mais registrado para notificações (app desinstalado ou notificações desativadas).',
  'messaging/invalid-registration-token': 'Token de notificação do dispositivo inválido.',
  'messaging/invalid-argument':
    'Dados da notificação inválidos (verifique título, mensagem ou o link de destino).',
  'messaging/message-rate-exceeded': 'Limite de envios excedido. Tente novamente mais tarde.',
  'messaging/device-message-rate-exceeded': 'Limite de envios para este dispositivo excedido.',
  'messaging/quota-exceeded': 'Cota de envio de notificações excedida.',
  'messaging/server-unavailable': 'Servidor do Firebase indisponível no momento. Tente novamente.',
  'messaging/internal-error': 'Erro interno do Firebase ao enviar a notificação.',
  'messaging/mismatched-credential':
    'Credenciais do projeto não correspondem ao dispositivo do aluno.',
  'messaging/authentication-error': 'Falha de autenticação com o serviço de notificações.',
};

export const translateNotificationError = (code, message) =>
  ERROR_MESSAGES[code] || message || 'Ocorreu um erro ao enviar a notificação.';

// Status que representam algo dando errado — inclui `partial`, em que parte dos
// dispositivos recebeu e parte não. `error` cobre docs legados.
export const isFailureStatus = (status) =>
  status === 'failed' || status === 'error' || status === 'partial';

// "Entregue a X de Y dispositivos". Devolve null para envios antigos, gravados
// antes de a função contabilizar entrega — a linha some em vez de mentir "0 de 0".
export const formatDeliveryCounts = (item) => {
  const sent = item?.sentCount;
  const failed = item?.failedCount;
  if (typeof sent !== 'number' || typeof failed !== 'number') return null;

  const total = sent + failed;
  if (total === 0) return 'Nenhum dispositivo recebeu';

  const plural = total === 1 ? 'dispositivo' : 'dispositivos';
  return `Entregue a ${sent.toLocaleString('pt-BR')} de ${total.toLocaleString('pt-BR')} ${plural}`;
};
